import { initialStateOptions } from '@/utils/pagination-utils';

import moment from 'moment';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const statusOptions = [
  {
    id: 'TODAS',
    description: 'Todas',
    value: null,
  },
  {
    id: 'EMITIDAS_ONTEM',
    description: 'Emitidas ontem',
    value: () => {
      const yesterday = moment().subtract(1, 'day').format('YYYY-MM-DD');
      return `dataEmissao = ${yesterday}`;
    },
  },
  {
    id: 'EMITIDAS_ESTA_SEMANA',
    description: 'Emitidas esta semana',
    value: () => {
      const startOfWeek = moment().startOf('week').format('YYYY-MM-DD');
      const endOfWeek = moment().endOf('week').format('YYYY-MM-DD');
      return `dataEmissao >= ${startOfWeek} and dataEmissao <= ${endOfWeek}`;
    },
  },
];

const state = {
  selectedStatus: statusOptions[0],
  statusOptions,
  searchText: null,
  empresa: null,
  dataInicial: null,
  dataFinal: null,
  fornecedor: [],
  notasSemVinculo: false,
  listOptions: initialStateOptions('dataHoraEmissao'),
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
